import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// material
import { alpha, styled } from '@mui/material/styles';

import { Card, Box, Button, Popover, } from '@mui/material';
import { LoadingButton } from '@mui/lab';


import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import PropTypes from 'prop-types';

import AlertDialog from '../../AlertDialog';
import NewDeviceRequestFormModal from './NewDeviceRequestFormModal'
import AddUserToOrganizationModal from './AddUserToOrganizationModal';
import { DateRangePickerDialog, ExportDataFilterModal } from '../app';
import CreateOrganizationModal from './CreateOrganizationModal';
import { useAuth } from '../../customContextProviders/AuthContext';
import { ExportMerchantReport, ExportMerchantReportWithFilter, ExportTransactionReport } from '../../../network/Merchants'
import { getDateINYMD } from '../../../utils/formatTime'
import { parseValidationErrorMessage } from '../../../utils/Utilities';
import { APP_CONSTANTS } from '../../../URLConstants';



// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: "#FFFFFF"
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));




const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 300,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};







export default function DeviceOrderdButtons({ _opneAssignedModal, _handleClose, onAction }) {

  const { sessionUserData } = useAuth()
  const navigate = useNavigate()

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const [requestProcessing, setRequestProcessing] = useState({
    merchantExport: false,
    data: null
  });



  const [isDeviceRequestModalOpen, setIsDeviceRequestModalOpen] = useState(false);
  const [isCreateOrganizationModalOpen, setIsCreateOrganizationModalOpen] = useState(false);
  const [isAddMerchantModalOpen, setIsAddMerchantModalOpen] = useState(false);
  const [isAddUserToOrganizationModalOpen, setIsAddUserToOrganizationModalOpen] = useState(false)

  const [requestDeviceAnchorEl, setRequestDeviceAnchorEl] = useState(null);
  const [exportDataAnchorEl, setExportDataAnchorEl] = useState(null);
  const [isDateRangeDialogOpen, setIsDateRangeDialogOpen] = useState(false)

  const [isExportDataFilterModalOpen,setIsExportDataFilterModalOpen]=useState(false)

  const requestDeviceDropdowOpen = Boolean(requestDeviceAnchorEl);
  const exportDataeDropdowOpen = Boolean(exportDataAnchorEl);
  const requestDeviceDropdownId = requestDeviceDropdowOpen ? 'requestDevice-popover' : undefined;
  const exportDataDropdownId = exportDataeDropdowOpen ? 'exportData-popover' : undefined;


  const handleRequestDeviceDropdownOpen = (event) => {
    setRequestDeviceAnchorEl(event.currentTarget);
  };

  const handleRequestDeviceDropdownClose = () => {
    setRequestDeviceAnchorEl(null);
  };

  function onNewDeviceRequestModalAction(d) {
    alert(d)
  }

  const handleExportDataDropdownOpen = (event) => {
    setExportDataAnchorEl(event.currentTarget);
  };

  const handleExportDataDropdownClose = () => {
    setExportDataAnchorEl(null);
  };


  function onCreateOrganizationModalAction(action, data) {
    onAction(action, data) 
  }

  function onAddUserToOrganizationModalAction(d) {
    alert(d)
  }

  // function requestMerchantReportExport(fromDate, toDate) {

  //   setRequestProcessing({ ...requestProcessing, merchantExport: true })

  //   ExportMerchantReport(sessionUserData?.user?.role !== "superadmin" ? sessionUserData?.user?.organization?.id : "",
  //     fromDate, toDate).then((res) => {
  //       setRequestProcessing({ ...requestProcessing, merchantExport: false })
  //       window.open(res?.data?.data, '_blank')
  //       setAlertDialogMetas({ ...alertDialogMetas, message: "File has been downloaded in your system", title: "Merchant Report", btnLabel: "OK" });
  //       setOpenAlertDialog(true)

  //     }).catch((err) => {
  //       setRequestProcessing({ ...requestProcessing, merchantExport: false })
  //       setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "Failed to process", btnLabel: "OK" });
  //       setOpenAlertDialog(true)
  //     })

  // }

  function requestTransactionReportExport(fromDate, toDate) {

    setRequestProcessing({ ...requestProcessing, merchantExport: true })

    ExportTransactionReport(sessionUserData?.user?.role !== "superadmin" ? sessionUserData?.user?.organization?.id : "",
      fromDate, toDate).then((res) => {
        setRequestProcessing({ ...requestProcessing, merchantExport: false })
        window.open(res?.data?.data, '_blank')
        setAlertDialogMetas({ ...alertDialogMetas, message: "File has been downloaded in your system", title: "Transaction Report", btnLabel: "OK" });
        setOpenAlertDialog(true)

      }).catch((err) => {
        setRequestProcessing({ ...requestProcessing, merchantExport: false })
        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "Failed to process", btnLabel: "OK" });
        setOpenAlertDialog(true)
      })

  }


  function onDateRangeSelectedAction(fromDate, todate, data) {

    if (fromDate === undefined || todate === undefined || fromDate === null || todate === null) {
      setAlertDialogMetas({ ...alertDialogMetas, message: "Please select Date Range.", title: "", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return false
    }

    // if (data === APP_CONSTANTS.MERCHANT_EXPORT_REPORT)
    //   requestMerchantReportExport(getDateINYMD(fromDate), (getDateINYMD(todate)))
    // else 
    if (data === APP_CONSTANTS.TRANSACTION_EXPORT_REPORT)
      requestTransactionReportExport(getDateINYMD(fromDate), (getDateINYMD(todate)))
  }

  function onExportDataFilterModalAction(filterPayload){

    if (filterPayload?.startDate === undefined || filterPayload?.endDate === undefined || filterPayload?.startDate === null || filterPayload?.endDate === null) {
      setAlertDialogMetas({ ...alertDialogMetas, message: "Please select Date Range.", title: "", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return false
    }


    if (filterPayload?.actionData === APP_CONSTANTS.RENT_STATUS_EXPORT_REPORT || filterPayload?.actionData === APP_CONSTANTS.MERCHANT_EXPORT_REPORT)
        requestMerchantReportExportWithFilter(filterPayload)
  

  }


  function requestMerchantReportExportWithFilter(filterPayload) {


        const payload = {
          "organizationId": sessionUserData?.user?.role !== "superadmin" ? sessionUserData?.user?.organization?.id : "",
          "from_date": getDateINYMD(filterPayload?.startDate),
          "to_date": getDateINYMD(filterPayload?.endDate)
        };

        if (filterPayload?.rentStatus !== null) {
          payload.rent = filterPayload?.rentStatus;
        }

        if (filterPayload?.zone !== null) {
          payload.zone_name = filterPayload?.zone.replace(/\s+/g, '').toLowerCase();
        }

    setRequestProcessing({ ...requestProcessing, merchantExport: true })


    ExportMerchantReportWithFilter(payload).then((res) => {
        setRequestProcessing({ ...requestProcessing, merchantExport: false })
        window.open(res?.data?.data, '_blank')
        setAlertDialogMetas({ ...alertDialogMetas, message: "File has been downloaded in your system", title: "Merchant Report", btnLabel: "OK" });
        setOpenAlertDialog(true)

      }).catch((err) => {
        setRequestProcessing({ ...requestProcessing, merchantExport: false })
        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "Failed to process", btnLabel: "OK" });
        setOpenAlertDialog(true)
      })

  }


  return (

    <Box>
      <Box sx={{ pt: 1, pb: 1, mt:1 }}>
        <Box >
          {
            sessionUserData?.user?.role !== APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN &&
              sessionUserData?.user?.role !== APP_CONSTANTS?.L1_SUPPORT_USER_ROLE &&
              sessionUserData?.user?.role !== APP_CONSTANTS?.L2_SUPPORT_USER_ROLE
              ?
              <Button variant="contained" color="whitebg" endIcon={<KeyboardArrowDownRoundedIcon />} size="small" sx={{ mr: 1, minHeight: '5vh', minWidth: 110, mb:0.5}} data-testid='order-device-button' onClick={handleRequestDeviceDropdownOpen} >Order Device</Button>
              :
              null
          }
          <Popover
            id={requestDeviceDropdownId}
            sx={{
              '& .MuiPopover-paper': {
                p: 2,
                mt: 1
              }
            }}
            open={requestDeviceDropdowOpen}
            anchorEl={requestDeviceAnchorEl}
            onClose={handleRequestDeviceDropdownClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            data-testid="request-device-dropdown"
          >
            <div><Button data-testid='add-merchant-button' sx={{ minWidth: 150, fontWeight:600 }} onClick={() => { setIsDeviceRequestModalOpen(true); handleRequestDeviceDropdownClose() }}>Add Merchant</Button></div>
            <div><Button sx={{ minWidth: 150, fontWeight: 600 }} onClick={() => {
              handleRequestDeviceDropdownClose(); setAlertDialogMetas({ ...alertDialogMetas, message: "This feature is coming soon, keep checking this space.", title: "Coming Soon...", btnLabel: "OK" });
              setOpenAlertDialog(true)
            }}>Request Status</Button></div>

          </Popover>

          {
            sessionUserData?.user?.role !== APP_CONSTANTS?.L1_SUPPORT_USER_ROLE ?
              <LoadingButton loading={requestProcessing?.merchantExport} variant="contained" color="whitebg" size="small" endIcon={<KeyboardArrowDownRoundedIcon />} sx={{ mr: 1, minHeight: '5vh', minWidth: 120, mb:0.5}} data-testid='export-data-button' onClick={handleExportDataDropdownOpen} >Export Data</LoadingButton>
              :
              null
          }
          
          <Popover
            id={exportDataDropdownId}
            sx={{
              '& .MuiPopover-paper': {
                p: 2,
                mt: 1
              }
            }}
            open={exportDataeDropdowOpen}
            anchorEl={exportDataAnchorEl}
            onClose={handleExportDataDropdownClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            data-testid='export-data-dropdown'
          >
            <div><Button data-testid='device-merchant-report' sx={{ minWidth: 150 }} 

              onClick={() => {
                handleExportDataDropdownClose();
                setIsExportDataFilterModalOpen(true);
                setRequestProcessing({ ...requestProcessing, data: APP_CONSTANTS.MERCHANT_EXPORT_REPORT })
              }}

            >Device & Merchant Report</Button></div>
            <div><Button data-testid='transaction-history-button' sx={{ minWidth: 150}} onClick={() => {

              handleExportDataDropdownClose();
              setIsDateRangeDialogOpen(true);
              setRequestProcessing({ ...requestProcessing, data: APP_CONSTANTS.TRANSACTION_EXPORT_REPORT })

            }}>Transaction History</Button></div>
            {process.env.REACT_APP_ENVIRONMENT !== "common_dashboard" && (

              <div><Button data-testid='rent-status-button' sx={{ minWidth: 150}}
              onClick={() => {
                handleExportDataDropdownClose();
                setIsExportDataFilterModalOpen(true);
                setRequestProcessing({ ...requestProcessing, data: APP_CONSTANTS.RENT_STATUS_EXPORT_REPORT })
              }}
              
              >Rent Status Report</Button></div>

          )}
          </Popover>


          {
            sessionUserData?.user?.role === 'superadmin' ?
              <Button variant="contained" color="whitebg" size="small" sx={{ minHeight: '5vh', ml: 1, minWidth: 120 }} data-testid='create-org-button' onClick={() => setIsCreateOrganizationModalOpen(true)}>Create Organization</Button>
              :
              null
          }

          {
            sessionUserData?.user?.role === 'admin' ?
              <Button variant="contained" color="whitebg" size="small" sx={{ minHeight: '5vh', ml: 0, mb:0.5, minWidth: 120 }} data-testid='add-new-user-button' onClick={() => setIsAddUserToOrganizationModalOpen(true)}>Add New User</Button>
              :
              null
          }
        </Box>
      </Box>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />
      <NewDeviceRequestFormModal opneAssignedModal={isDeviceRequestModalOpen} handleClose={() => setIsDeviceRequestModalOpen(false)} onAction={(d) => onNewDeviceRequestModalAction(d)} />
      <CreateOrganizationModal opneAssignedModal={isCreateOrganizationModalOpen} handleClose={() => setIsCreateOrganizationModalOpen(false)} onAction={(d, data) => onCreateOrganizationModalAction(d, data)} />
      <AddUserToOrganizationModal organizationData={null} opneAssignedModal={isAddUserToOrganizationModalOpen} handleClose={() => setIsAddUserToOrganizationModalOpen(false)} onAction={(d) => onAddUserToOrganizationModalAction(d)} />
      <DateRangePickerDialog actionData={requestProcessing?.data} openDateRangeModal={isDateRangeDialogOpen} handleClose={() => setIsDateRangeDialogOpen(false)} onAction={(fromDate, toDate, data) => onDateRangeSelectedAction(fromDate, toDate, data)} />

      <ExportDataFilterModal actionData={requestProcessing?.data} openDateRangeModal={isExportDataFilterModalOpen} handleClose={() => setIsExportDataFilterModalOpen(false)} onAction={(filetrPayload) => onExportDataFilterModalAction(filetrPayload)} />

    </Box>


  );
}


DeviceOrderdButtons.propTypes = {
  _opneAssignedModal: PropTypes.bool,
  _handleClose: PropTypes.func,
  onAction: PropTypes.func
}


